import { Box, Stack, Step, StepLabel, Stepper } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import LegalReg from "../LegalReg";
import ConfirmAndCancelButtons from "../../../../../components/buttons/ConfirmAndCancelButtons";
import TermsLoginAndLanguageFooter from "../TermsLoginAndLanguageFooter";
const steps = [
  "OrganizationInfoStepper",
  "LocationInfoStepper",
  "AccountInfoStepper",
];

const fieldMappings = {
  0: ["firstName", "phoneNumber", "oib", "personToContact", "shelter"],
  1: ["address", "province", "city", "place", "zipcode", "country"],
  2: ["email", "username", "clinic", "password", "confirmPassword"],
};

export default function LegalStepper({ onCancel }) {
  const [activeStep, setActiveStep] = React.useState(0);

  const { t } = useTranslation();
  const [completed, setCompleted] = React.useState({});
  const [stepErrors, setStepErrors] = React.useState({});
  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const getPageErrors = (errors) => {
    const errorKeys = Object.keys(errors);
    const newErrors = {};

    Object.entries(fieldMappings).forEach(([step, fields]) => {
      newErrors[step] = fields.some((field) => errorKeys.includes(field));
    });

    setStepErrors((prev) =>
      JSON.stringify(prev) !== JSON.stringify(newErrors) ? newErrors : prev
    );
  };

  const isStepFailed = (stepIndex) => stepErrors[stepIndex] || false;

  return (
    <Stack>
      <Stepper nonLinear activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => {
          const labelProps = {};
          if (isStepFailed(index)) {
            labelProps.error = true;
          }

          return (
            <Step key={label}>
              <StepLabel {...labelProps}>{t(label)}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <Stack
        minHeight={"65vh"}
        mt={2}
        display={"flex"}
        justifyContent={"start"}
        height={"100%"}
      >
        <LegalReg activeStep={activeStep} getPageErrors={getPageErrors} />
      </Stack>
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <ConfirmAndCancelButtons
          isStepper={true}
          cancelTitle="Cancel"
          backTitle="Back"
          nextTitle="Next"
          enableConfirmButton={false}
          backButtonProps={{
            disabled: activeStep === 0,
          }}
          nextButtonProps={{
            disabled: isLastStep(),
          }}
          onCancel={onCancel}
          onBack={handleBack}
          onNext={handleNext}
          confirmButtonType="submit"
          testId="auth.signup.stepper"
        />
      </Box>
      <TermsLoginAndLanguageFooter />
    </Stack>
  );
}
